<ion-content> <h1>How it works</h1> </ion-content>
